
'use strict';

!(function ($) {

  const User = (function () {

    const COMPANY_KEY = company_key;
    const API_URL = api_url;
    const SUSCRIBER_GET_DATA = 'suscribers/get';
    const SUSCRIBER_EMAIL =
      typeof logged_in_suscribed_email != 'undefined' ?
        logged_in_suscribed_email :
        '';
    const isLoggedIn = SUSCRIBER_EMAIL ? true : false;

    let user = {};
    let userAval = {};

    let _userEvent = new Event("user_data_loaded", { bubbles: true });
    let _userAvalEvent = new Event("user_aval_loaded", { bubbles: true });

    // if (isLoggedIn && !user) {
    //   _fetchUserData();
    // }

    function _getUser() {
      return user;
    }

    function _getUserAval() {
      return userAval;
    }

    function _fetchUserAval({ empresa_aval }) {
      if (isLoggedIn) {
        $.ajax({
          type: 'GET',
          url: API_URL + SUSCRIBER_GET_DATA,
          data: {
            'email': SUSCRIBER_EMAIL,
            'empresa_id': empresa_aval,
          },
          dataType: 'json',
        })
        .done(function (data, textStatus, jqXHR) {
          if (data) {
            userAval = data;
            window.dispatchEvent(_userAvalEvent);
          }
        })
        .fail(function (jqXHR, textStatus, err) {
          console.error(err);
          throw new Error(err);
        });
      } else {
        console.log('Usuario no registrado');
      }
    }

    function _fetchUserData() {
      // load userData
      $.ajax({
        type: 'GET',
        url: API_URL + SUSCRIBER_GET_DATA,
        data: {
          'email': SUSCRIBER_EMAIL,
          'empresa_id': COMPANY_KEY,
        },
        dataType: 'json',
      })
        .done(function (data, textStatus, jqXHR) {
          if (data) {
            user = data;
            window.dispatchEvent(_userEvent);
          }
        })
        .fail(function (jqXHR, textStatus, err) {
          console.error(err);
          throw new Error(err);
        });
    }

    return {
      get: _getUser,
      getUserAval: _getUserAval,
      fetchUser: _fetchUserData,
      fetchUserAval: _fetchUserAval,
    }

  })();

  window.user = User;

}(jQuery));
